import Image from 'next/image'
import { cn } from '~shared/utils/cn'
import photographPicture from './images/photograph.jpg'
import workHumanPicture from './images/workHuman.jpg'

// ─── Constants ────────────────────────────────────────────────────────────────

const CARDS = [
  { title: 'Только актуальный контент' },
  {
    title:
      'Мы регулярно отслеживаем изменения на рынке и адаптируем программы под новые реалии'
  },
  {
    title:
      'Мы проводим внутренние исследования и на их основе адаптируем программы под требования работодателей'
  },
  {
    title:
      'Программа разработана так, чтобы ее было комфортно проходить в удаленном формате, без отрыва от основной деятельности'
  }
]


// ─── Card ─────────────────────────────────────────────────────────────────────

const Card = ({
  title,
  children
}: {
  title: string
  children: React.ReactNode
}) => (
  <div className='flex flex-col items-start gap-[16px] 2lg:gap-[32px] p-[24px] md:p-[32px] rounded-[16px] 2lg:rounded-[32px] bg-white'>
    <div className='shrink-0'>{children}</div>
    <span className='text-black font-normal text-[14px] md:text-[16px] 2lg:text-[20px] leading-[120%]'>
      {title}
    </span>
  </div>
)

// ─── IconCircle ───────────────────────────────────────────────────────────────

const IconCircle = ({ variant }: { variant: 'default' | 'accent' }) => (
  <div
    className='w-[40px] h-[40px] 2lg:w-[56px] 2lg:h-[56px] rounded-full'
    style={{ backgroundColor: variant === 'accent' ? '#7D5EE4' : '#4BAC89' }}
  />
)

// ─── IconPlay ─────────────────────────────────────────────────────────────────

const IconPlay = ({ variant }: { variant: 'default' | 'accent' }) => (
  <svg
    viewBox='0 0 48 152'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className='w-[25px] h-[48px] 2lg:w-[48px] 2lg:h-[150px]'>
    <path
      d='M46.6614 79.3652C47.651 77.2309 47.651 74.7691 46.6614 72.6348L15.2578 4.9065C11.6526 -2.86877 0 -0.298675 0 8.27174V143.728C0 152.299 11.6526 154.869 15.2578 147.093L46.6614 79.3652Z'
      fill={variant === 'accent' ? '#FB5449' : '#ACBF2F'}
    />
  </svg>
)

// ─── Component ────────────────────────────────────────────────────────────────

export const AboutTraining = () => {
  return (
    <section className='py-[56px] 2lg:py-[80px]'>
      <div className='mx-auto px-[16px] box-border max-w-[672px] md:max-w-[864px] 2lg:max-w-[1280px]'>
        <div className='p-[24px] md:p-[32px] 2lg:p-[80px] rounded-[16px] 2lg:rounded-[32px] bg-black'>

          <h2 className='text-[32px] md:text-[40px] 2lg:text-[48px] font-medium text-white mb-[32px] 2lg:mb-[48px]'>
            Об обучении
          </h2>

          <div className='grid grid-cols-1 md:grid-cols-2 gap-[40px] md:gap-[32px]'>

            {/* Card 0: фото */}
            <Card title={CARDS[0].title}>
              <Image
                src={photographPicture}
                alt='Фотограф'
                width={80}
                height={80}
                className='rounded-[16px] 2lg:w-[176px] 2lg:h-[176px] object-cover'
                quality={100}
              />
            </Card>

            {/* Card 1: 4 кружка 2×2 */}
            <Card title={CARDS[1].title}>
              <div className='grid grid-cols-2 gap-[4px] 2lg:gap-[8px]'>
                {[0, 1, 2, 3].map(idx => (
                  <IconCircle
                    key={idx}
                    variant={idx === 3 ? 'accent' : 'default'}
                  />
                ))}
              </div>
            </Card>

            {/* Card 2: 7 иконок play */}
            <Card title={CARDS[2].title}>
              <div className='flex flex-wrap'>
                {[0, 1, 2, 3, 4, 5, 6].map(idx => (
                  <IconPlay
                    key={idx}
                    variant={idx === 6 ? 'accent' : 'default'}
                  />
                ))}
              </div>
            </Card>

            {/* Card 3: фото */}
            <Card title={CARDS[3].title}>
              <Image
                src={workHumanPicture}
                alt='Работа за компьютером'
                width={80}
                height={80}
                className='rounded-[16px] 2lg:w-[176px] 2lg:h-[176px] object-cover'
                quality={100}
              />
            </Card>

          </div>
        </div>
      </div>
    </section>
  )
}